import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const groups = (rawClient) => ({
    create: allpeepPayloadEndpoint(rawClient, '/groups', 'post'),
    list: allpeepNoPayloadEndpoint(rawClient, '/groups'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/groups/:id'),
    findByHandle: allpeepNoPayloadEndpoint(rawClient, '/groups/by-handle/:handle'),
    update: allpeepPayloadEndpoint(rawClient, '/groups/:id', 'put'),
    delete: allpeepNoPayloadEndpoint(rawClient, '/groups/:id', 'delete'),
    members: allpeepNoPayloadEndpoint(rawClient, '/groups/:id/members'),
    join: allpeepNoPayloadEndpoint(rawClient, '/groups/:id/join', 'post'),
    leave: allpeepNoPayloadEndpoint(rawClient, '/groups/:id/leave', 'delete'),
    addMember: allpeepPayloadEndpoint(rawClient, '/groups/:id/members'),
    removeMember: allpeepNoPayloadEndpoint(rawClient, '/groups/:id/members/:memberId', 'delete'),
    setMemberRoles: allpeepPayloadEndpoint(rawClient, '/groups/:id/members/:memberId', 'put'),
});
